// import dateTime from '@/mixins/dateTime';

export default{
  // mixins: [dateTime],
  methods: {
    getGcodeInfoArray(info) {
      let $t = (val, data) => this.$t('fileGcodeInfo.' + val, data);
      return window.getGcodeInfoArray(info, window.getGcodeInfoAvailableData($t), $t);
    }
  }
}
